<template>

  <div id="page-user-list">

    <div class="vx-row flex justify-between">
      <div v-if="canManageFinancialSettings" class="vx-col">
        <div class="vx-row">
          <div class="vx-col">
            <vx-card class="set-view" :class="{'active-view' : activeView == 1}" @click="changeView(1)">
              <div slot="no-body" class="flex justify-center items-center px-4 py-1">
                <feather-icon icon="GridIcon" class="p-1 rounded-full text-success"></feather-icon>
                <h6 class="ml-2">{{ $i18n.t('HeaderView') }}</h6>
              </div>
            </vx-card>
          </div>
          <div class="vx-col">
            <vx-card class="set-view" :class="{'active-view' : activeView == 2}" @click="changeView(2)">
              <div slot="no-body" class="flex justify-center items-center px-4 py-1">
                <feather-icon icon="CreditCardIcon" class="p-1 rounded-full text-danger"></feather-icon>
                <h6 class="ml-2">{{ $i18n.t('TabularView') }}</h6>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
      <div v-if="canManageFinancialSettings" class="vx-col">
        <vx-card class="add-data" @click="openAddAccount">
          <div slot="no-body" class="flex justify-center items-center px-4 py-1">
            <feather-icon icon="PlusIcon" class="p-1 rounded-full text-info"></feather-icon>
            <h6 class="ml-2">{{ $i18n.t('AddNewData') }}</h6>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="mt-6">
      <vs-checkbox v-model="showHidden">Tampilkan akun tersembunyi ({{ hiddenCount }})</vs-checkbox>
      <p class="text-sm mt-2">Hide hanya menyembunyikan akun dari daftar ini. Nomor akun tetap terpakai; saldo, laporan, dan riwayat transaksi tetap tersimpan.</p>
    </div>

    <div class="vx-card p-6 pt-3 mt-6 tabular-view-member" v-show="loaded" :class="{'hide-view' : activeView == 1}">

      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">{{$i18n.t('SearchData')}}</label>
        <vs-input class="mb-4 md:mb-0 w-full" v-model="searchQuery" @input="updateSearchQuery" :placeholder="$i18n.t('SearchNotes')" />
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="tableData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <div class="flex flex-wrap justify-between items-center">

        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-3 border border-solid d-theme-border-grey-light rounded d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ tableData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : tableData.length }} dari {{ tableData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-left">
          <vs-pagination
            :total="totalPages"
            :max="7"
            v-model="currentPage" />
        </div>
      </div>

    </div>

    <div class="vx-card p-6 pt-3 mt-6 header-view-member" v-show="loaded" :class="{'hide-view' : activeView == 2}">
      <table class="accounts-table table table-collapse">
        <thead>
          <td v-if="canManageFinancialSettings">{{$i18n.t('Actions')}}</td>
          <td>{{$i18n.t('AccountCode')}}</td>
          <td>{{$i18n.t('AccountName')}}</td>
        </thead>
        <tbody>
          <template v-for="data in tableData">
            <tr  :key="data.code" :class="`row-level-${data.level}`">
              <td v-if="canManageFinancialSettings">
                <div class="flex justify-center">
                  <vs-button size="small" class="mr-2 px-3" color="success" type="filled" icon-pack="feather" icon="icon-edit" @click="showAccounts(data)">Edit</vs-button>
                  <vs-button size="small" class="mr-2 px-3" color="warning" type="border" :disabled="savingVisibility" @click="toggleVisibility(data)">{{ data.is_hidden ? 'Show' : 'Hide' }}</vs-button>
                  <vs-button size="small" class="px-3" color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="removeData(data)">{{$i18n.t('Delete')}}</vs-button>
                </div>
              </td>
              <td>
                {{ data.code }}
              </td>
              <td>
                <span class="divider" v-if="data.level == 4">
                  -----------------
                </span>
                <span class="divider" v-if="data.level == 3">
                  -----------
                </span>
                <span class="divider" v-if="data.level == 2">
                  -----
                </span>
                <label class="account-name">{{ data.name }}</label>
                <span v-if="data.is_hidden" class="text-warning ml-2">(Tersembunyi)</span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>


    <vs-prompt
        v-if="canManageFinancialSettings"
        :title="dataAccount.id ? 'Edit akun' : 'Tambah akun'"
        :accept-text="savingAccount ? 'Menyimpan...' : 'Simpan akun'"
        :cancel-text="$i18n.t('Cancel')"
        button-cancel = "border"
        @accept="submitAccount"
        :active.sync="displayPrompt"
        :is-valid="validateForm">
      <div>
        <form class="account-editor" @submit.prevent="submitAccount">
          <div class="w-full">
            <label class="text-sm opacity-75">{{$i18n.t('AccountCode')}}</label>
            <vs-input v-validate="'required'" name="code" class="w-full mt-2" placeholder="Kode Akun" v-model="dataAccount.code" :color="validateForm ? 'success' : 'danger'" v-mask="'##.##.##.###'"/>
          </div>
          <div class="w-full mt-6">
            <label class="text-sm opacity-75">{{$i18n.t('AccountName')}}</label>
            <vs-input v-validate="'required'" name="name" class="w-full mt-2" placeholder="Nama Akun" v-model="dataAccount.name" :color="validateForm ? 'success' : 'danger'" />
          </div>
          <div v-if="!dataAccount.id" class="account-metadata">
            <div><label for="new-account-kind">Jenis akun</label><select id="new-account-kind" v-model="dataAccount.account_kind" @change="onKindChange"><option value="POSTING">Akun transaksi</option><option value="HEADER">Header / kelompok akun</option></select></div>
            <p>{{ dataAccount.account_kind === 'HEADER' ? 'Header mengelompokkan akun, tidak menerima transaksi, dan harus berakhiran 000.' : 'Akun transaksi menggunakan kode lengkap dengan akhiran selain 000.' }}</p>
            <div><label for="new-account-category">Kategori akun</label><select id="new-account-category" v-model="dataAccount.account_category" @change="onCategoryChange"><option value="">Pilih kategori</option><option v-for="category in categoryOptions" :key="category.value" :value="category.value">{{ category.label }}</option></select></div>
            <div><label for="new-account-normal">Saldo normal</label><select id="new-account-normal" v-model="dataAccount.normal_balance"><option value="">Pilih saldo normal</option><option value="debit">Debit</option><option value="credit">Kredit</option></select><small>Arah saldo normal akun, bukan nominal saldo awal.</small></div>
            <p v-if="dataAccount.account_category" class="account-taxonomy"><strong>{{ isPermanentCategory ? 'Neraca' : 'Laba Rugi' }}</strong><br>{{ dataAccount.account_kind === 'HEADER' ? 'Header tidak ikut proses tutup buku.' : isPermanentCategory ? 'Saldo diteruskan ke tahun berikutnya.' : 'Saldo ditutup ke ekuitas saat tutup buku.' }}</p>
            <p>Setelah disimpan, atur identitas baru atau hubungan dengan akun tahun sebelumnya di <router-link to="/manage-coa">Manage COA</router-link>.</p>
          </div>
          <p v-else class="account-taxonomy mt-4">Kategori, saldo normal, dan identitas lintas tahun dikelola di <router-link to="/manage-coa">Manage COA</router-link>.</p>
          <div class="w-full mt-6">
            <label class="text-sm opacity-75">{{$i18n.t('InitBalance')}}</label>
            <vs-input v-validate="'required'" name="init" :disabled="!dataAccount.id && dataAccount.account_kind === 'HEADER'" v-money="money" class="w-full mt-2" v-model="dataAccount.init" :color="validateForm ? 'success' : 'danger'" />
          </div>
          <p v-if="!dataAccount.id" class="text-sm mt-2">Saldo awal menggunakan debit dikurangi kredit: positif untuk debit, negatif untuk kredit. Mutasi debit/kredit awal adalah 0.</p>
          <div v-if="dataAccount.id" class="vx-row mt-6">
            <div class="vx-col md:w-1/2">
              <!-- <div class="w-full mt-6"> -->
                <label class="text-sm opacity-75">{{$i18n.t('Debit')}}</label>
                <vs-input v-validate="'required|numeric'" name="debit" v-money="money" class="w-full mt-2" v-model="dataAccount.debit" :color="validateForm ? 'success' : 'danger'" />
              <!-- </div> -->
            </div>
            <div class="vx-col md:w-1/2">
              <!-- <div class="w-full mt-6"> -->
                <label class="text-sm opacity-75">{{$i18n.t('Credit')}}</label>
                <vs-input v-validate="'required|numeric'" name="credit" v-money="money" class="w-full mt-2" v-model="dataAccount.credit" :color="validateForm ? 'success' : 'danger'" />
              <!-- </div> -->
            </div>
          </div>
          <div v-if="dataAccount.id" class="w-full mt-6">
            <label class="text-sm opacity-75">{{$i18n.t('FinalBalance')}}</label>
            <vs-input v-validate="'required'" name="final" v-money="money" class="w-full mt-2" v-model="dataAccount.final" :color="validateForm ? 'success' : 'danger'" />
          </div>
        </form>
      </div>
    </vs-prompt>

  </div>
</template>

<script>
// i18n
import i18n from '@/i18n/i18n'
import { AgGridVue } from 'ag-grid-vue'
import { VMoney } from 'v-money'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import moduleAccount from '@/store/accounts/moduleAccount.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'


export default {
  components: {
    AgGridVue,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  directives: { money: VMoney },
  data () {
    return {
      activeId: null,
      activeView: 1,
      allAccounts: [],
      showHidden: false,
      savingVisibility: false,
      searchQuery: '',

      loaded: false,
      displayPrompt: false,
      savingAccount: false,
      categoryOptions: [
        { value: 'asset', label: 'Aset' }, { value: 'liability', label: 'Liabilitas' },
        { value: 'equity', label: 'Ekuitas' }, { value: 'income', label: 'Pendapatan' },
        { value: 'expense', label: 'Beban' }, { value: 'cost_of_sales', label: 'Harga Pokok Penjualan' },
        { value: 'other_income', label: 'Pendapatan Lain-lain' }, { value: 'other_expense', label: 'Beban Lain-lain' }
      ],

      dataAccount: {
        id: null,
        account_kind: 'POSTING',
        account_category: '',
        normal_balance: '',
        code: null,
        name: null,
        init: 0,
        debit: 0,
        credit: 0,
        final: 0
      },

      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      },

      // AgGrid
      gridApi: null,
      gridOptions: { context: { componentParent: this } },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'No',
          field: 'no',
          filter: true,
          width: 80
        },
        {
          headerName: i18n.t('AccountCode'),
          field: 'code',
          filter: true,
          width: 150
        },
        {
          headerName: 'Nama Akun',
          field: 'name',
          filter: true,
          width: 300
        },
        {
          headerName: 'Status daftar',
          field: 'is_hidden',
          valueFormatter: params => params.value ? 'Tersembunyi' : 'Ditampilkan',
          width: 140
        },
        {
          headerName: 'Init Balance',
          field: 'init',
          width: 150
          // hide: true,
        },
        {
          headerName: 'Debit',
          field: 'debit',
          hide: true
        },
        {
          headerName: 'Credit',
          field: 'credit',
          hide: true
        },
        {
          headerName: 'Final Balance',
          field: 'final',
          width: 150
          // hide: true,
        },
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 300,
          cellRendererFramework: 'CellRendererActions',
          cellRendererParams: {
            showAccounts : this.showAccounts.bind(this),
            getAccounts : this.getAccounts.bind(this),
            refreshAccounts : this.refreshAccounts.bind(this),
            toggleVisibility: this.toggleVisibility.bind(this)
          }
        }
      ],
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  computed: {
    tableData () {
      return this.allAccounts.filter(account => this.showHidden || !account.is_hidden)
    },
    hiddenCount () { return this.allAccounts.filter(account => account.is_hidden).length },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    isPermanentCategory () { return ['asset', 'liability', 'equity'].includes(this.dataAccount.account_category) },
    validNewMetadata () {
      if (this.dataAccount.id) return true
      const account = this.dataAccount
      if (!account.account_category || !account.normal_balance) return false
      if (account.account_kind === 'HEADER') return String(account.code).endsWith('.000') && Number(String(account.init).replace(/\./g, '')) === 0
      return !String(account.code).endsWith('.000') && String(account.code).substring(3, 5) !== '00' && String(account.code).substring(6, 8) !== '00'
    },
    validateForm () {
      return !this.savingAccount && !this.errors.any() && this.validNewMetadata &&
      /^\d{2}\.\d{2}\.\d{2}\.\d{3}$/.test(this.dataAccount.code || '') &&
      !!(this.dataAccount.name || '').trim() &&
      this.isValidNumber(this.dataAccount.init) &&  // Custom validasi angka
      this.isValidNumber(this.dataAccount.debit) &&
      this.isValidNumber(this.dataAccount.credit) &&
      this.isValidNumber(this.dataAccount.final)
    },
    company () {
      return JSON.parse(localStorage.getItem('activeCompany'))
    },
    canManageFinancialSettings () {
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}')
      return [0, 1].includes(Number(user.role_id))
    }
  },
  created () {
    if (!moduleAccount.isRegistered) {
      this.$store.registerModule('accounts', moduleAccount)
      moduleAccount.isRegistered = true
    }
    if (!this.canManageFinancialSettings) {
      this.columnDefs = this.columnDefs.filter(column => column.headerName !== 'Actions')
    }
    this.loading()
    this.getAccounts()
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    this.gridOptions.api.sizeColumnsToFit()
  },
  methods: {
    toggleVisibility (data) {
      if (!this.canManageFinancialSettings || this.savingVisibility) return
      this.savingVisibility = true
      this.$store.dispatch('accounts/updateAccountVisibility', { id: data.id, is_hidden: !data.is_hidden })
        .then(res => {
          const account = this.allAccounts.find(account => account.id === data.id)
          if (account) account.is_hidden = res.data.data.is_hidden
          this.$vs.notify({ color: 'success', title: 'Berhasil', text: res.data.message })
        })
        .catch(err => {
          const response = err.response && err.response.data
          this.$vs.notify({ color: 'danger', title: 'Gagal mengubah status akun', text: (response && response.message) || 'Status akun tidak dapat disimpan.' })
        })
        .finally(() => { this.savingVisibility = false })
    },
    openAddAccount () {
      if (this.savingAccount || !this.canManageFinancialSettings) return
      this.resetForm()
      this.$validator.reset()
      this.displayPrompt = true
    },
    onCategoryChange () {
      this.dataAccount.normal_balance = this.dataAccount.account_category ? (['asset', 'expense', 'cost_of_sales', 'other_expense'].includes(this.dataAccount.account_category) ? 'debit' : 'credit') : ''
    },
    onKindChange () { if (this.dataAccount.account_kind === 'HEADER') this.dataAccount.init = 0 },
    isValidNumber (value) {
      // Menerima angka positif/negatif dan maksimal 13 digit
      const numValue = String(value).replace(/\./g, '') // Hapus pemisah ribuan
      return /^-?\d{1,13}$/.test(numValue)
    },
    loading () {
      this.loaded = false
      this.$vs.loading({
        type: 'border',
        color: 'primary',
        text: 'Wait a minute, It\'s getting data.'
      })
    },
    onLoaded () {
      this.loaded = true
      this.$vs.loading.close()
    },
    getAccounts () {
      const self      = this
      self.allAccounts  = []
      this.$store.dispatch('accounts/fetchAccounts', {
        company_id: this.company.id
      })
        .then(res => {

          const data = res.data.data

          data.forEach((value, index) => {
            self.allAccounts.push({
              id      : value.id,
              is_hidden: !!value.is_hidden,
              no      : index + 1,
              code    : value.account_code,
              name    : value.name,
              level   : value.level,
              init    : value.init_balance,
              debit   : value.debit,
              credit  : value.credit,
              final   : value.final_balance
            })
          })
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
        .finally(() => {
          this.onLoaded()
        })
    },
    showAccounts (data) {
      if (!this.canManageFinancialSettings) return

      const self = this

      self.displayPrompt = true
      Object.assign(self.dataAccount, {
        id: data.id,
        code: data.code,
        name: data.name,
        init: data.init,
        debit: data.debit,
        credit: data.credit,
        final: data.final
      })
    },
    submitAccount () {
      if (!this.canManageFinancialSettings || !this.validateForm) return

      const self = this

      this.$validator.validateAll().then(result => {
        if (result && !this.savingAccount) {
          this.savingAccount = true
          let dispatch = null
          let body = null
          const formData = new FormData()

          // Fungsi untuk mengkonversi format v-money ke angka
          const convertMoneyToNumber = (moneyValue) => {
            if (!moneyValue && moneyValue !== 0) return '0'
          
            // Hapus pemisah ribuan (titik) dan ubah koma menjadi titik untuk desimal
            let value = String(moneyValue)
          
            // Hapus semua titik (pemisah ribuan)
            value = value.replace(/\./g, '')
          
            // Jika ada koma (desimal), ubah menjadi titik
            // Tapi dari konfigurasi money, precision: 0, jadi tidak ada desimal
            value = value.replace(/,/g, '.')
          
            // Parse ke float dan pastikan valid
            const num = parseFloat(value)
            return isNaN(num) ? '0' : num.toString()
          }

          // Konversi semua field uang ke angka murni
          const initBalance = convertMoneyToNumber(self.dataAccount.init)
          const debit = convertMoneyToNumber(self.dataAccount.debit)
          const credit = convertMoneyToNumber(self.dataAccount.credit)
          const finalBalance = convertMoneyToNumber(self.dataAccount.final)

          formData.set('company_id', self.company.id)
          formData.set('level1', self.dataAccount.code.substring(0, 2))
          formData.set('level2', self.dataAccount.code.substring(3, 5))
          formData.set('level3', self.dataAccount.code.substring(6, 8))
          formData.set('code', self.dataAccount.code.substring(9, 12))
          formData.set('name', self.dataAccount.name)
          formData.set('init_balance', initBalance)  // Gunakan nilai yang sudah dikonversi
          formData.set('debit', debit)               // Gunakan nilai yang sudah dikonversi
          formData.append('credit', credit)          // Gunakan nilai yang sudah dikonversi
          formData.append('final_balance', finalBalance) // Gunakan nilai yang sudah dikonversi

          if (self.dataAccount.id === null) {
            formData.set('account_kind', self.dataAccount.account_kind)
            formData.set('account_category', self.dataAccount.account_category)
            formData.set('normal_balance', self.dataAccount.normal_balance)
            dispatch = 'accounts/createAccount'
            body = formData
          } else {
            dispatch = 'accounts/updateAccount'
            body = {
              id   : self.dataAccount.id,
              data : formData
            }

            formData.append('_method', 'PUT')
          }

          this.$store.dispatch(dispatch, body)
            .then(function () {
              self.displayPrompt = false
              self.refreshAccounts()
              self.$vs.notify({
                color: 'success',
                title: 'Berhasil',
                text: 'Data berhasil disubmit'
              })
            })
            .catch(err => {
              self.displayPrompt = true
              const response = err.response && err.response.data
              const errors = response && response.errors
              const first = errors && Object.keys(errors).length ? errors[Object.keys(errors)[0]][0] : null
              self.$vs.notify({ color: 'danger', title: 'Gagal menyimpan akun', text: first || (response && response.message) || 'Akun tidak dapat disimpan.' })
            }).finally(() => { this.savingAccount = false })
        }
      })
    },
    refreshAccounts () {
      this.resetForm()
      this.loading()
      this.getAccounts()
    },
    resetForm () {
      Object.assign(this.dataAccount, {
        id: null,
        account_kind: 'POSTING',
        account_category: '',
        normal_balance: '',
        code: null,
        name: null,
        init: 0,
        debit: 0,
        credit: 0,
        final: 0
      })
    },
    removeData (data) {
      if (!this.canManageFinancialSettings) return

      this.activeId = data.id

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: i18n.t('Warning'),
        text: `${i18n.t('DeleteNotes')} "${data.name}" dari tahun buku ${localStorage.getItem('selectedYear')}? Account hanya dapat dihapus jika belum memiliki transaksi, saldo, archive, atau sub-account.`,
        accept: this.deleteRecord,
        acceptText: i18n.t('Delete'),
        cancelText: i18n.t('Cancel')
      })
    },
    deleteRecord () {
      if (!this.canManageFinancialSettings) return

      this.$store.dispatch('accounts/deleteAccount', this.activeId)
        .then(() => {
          this.refreshAccounts()
          this.showDeleteSuccess()
        })
        .catch(err => {
          const response = err && err.response && err.response.data
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: (response && response.message) || 'Account tidak dapat dihapus.'
          })
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: i18n.t('Success'),
        text: i18n.t('DeleteSuccess')
      })
    },
    changeView (key) {
      this.activeView = key
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }
      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  }
}
</script>

<style lang="scss">
  @import './style.scss';
</style>

<style scoped>
.account-editor { max-height: 65vh; overflow-y: auto; padding: 2px 8px 12px 2px; }
.account-metadata { margin-top: 20px; }
.account-metadata > div { margin-top: 14px; }
.account-metadata label { display: block; font-size: 13px; margin-bottom: 6px; }
.account-metadata select { width: 100%; min-height: 40px; padding: 8px; border: 1px solid #bac5d5; border-radius: 6px; background: #fff; color: #31415a; }
.account-metadata p, .account-metadata small { font-size: 12px; line-height: 1.6; margin-top: 8px; display: block; }
.account-taxonomy { padding: 12px; background: var(--app-primary-soft); border-radius: 6px; font-size: 13px; }
</style>
